import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonBadge, IonIcon, IonItem, IonLabel, IonList, IonMenuToggle } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { AppTab, ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { Observable } from 'rxjs';
import { MarketService } from '../../../market/application/market.service';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: ['./menu-main.component.scss'],
  imports: [
    IonBadge,
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IonList,
    IonItem,
    IonMenuToggle,
    IonIcon,
    IonLabel,
  ],
})
export class MenuMainComponent {
  private readonly accountService = inject(AccountService);
  private readonly marketService = inject(MarketService);

  public readonly userCapabilities$: Observable<ECapabilities[]> = this.accountService.userCapabilities$;
  public readonly ECapabilities = ECapabilities;

  public readonly availableFreightsCount = this.marketService.countTotal;

  protected AppTab = AppTab;

  // constructor() {}
}
